import {capitalizeFirstLetter} from './CapitalizeLetters'

const getHour = (dateString: string) => {
  const date = new Date(dateString)
  const output = date.toLocaleString('es-es', { hour: 'numeric', minute: 'numeric', hour12: true })

  return capitalizeFirstLetter(output)
}

const getDay = (dateString: string) => {
  const date = new Date(dateString)
  const output = date.toLocaleString('es-es', { weekday: 'long', day: 'numeric' })

  return capitalizeFirstLetter(output)
}

const getMonth = (dateString: string) => {
    const date = new Date(dateString)
    const output = date.toLocaleString('es-es', { month: 'long'})

    return capitalizeFirstLetter(output)
}

const getMonthAndYear = (dateString: string) => {
  const date = new Date(dateString)
  const output = date.toLocaleString('es-es', { month: 'long', year: 'numeric' })

  return capitalizeFirstLetter(output)
}

const getDayMonthAndYear = (dateString: string) => {
    const date = new Date(dateString)
    const output = date.toLocaleString('es-es', { day: 'numeric' , month: 'long', year: 'numeric' })

    return capitalizeFirstLetter(output)
}

const isDateToday = (dateString: string) => {
  const today = new Date()
  const currentDate = new Date(dateString)

  return currentDate.toDateString() === today.toDateString()
}

const getDateStringFromIso = (dateTime: string) => {
    const d = new Date(dateTime)
    // Date string
    return d.getFullYear().toString().padStart(4, '0') + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + d.getDate().toString().padStart(2, '0');
}


const getTimeStringFromIso = (dateTime: string) => {
    const d = new Date(dateTime)
    // Time string
    return d.getHours().toString().padStart(2, '0') + ':' + d.getMinutes().toString().padStart(2, '0') + ':' + d.getSeconds().toString().padStart(2, '0');
}

const dateToIso = (dateTime: string): string => {
    const d = new Date(dateTime)

    return d.toISOString();
}

const dateFromIso = (isoString: string | null): string|null => {
    if (isoString === null) {
        return null;
    }
    return isoString.substring(0, 16);
}

const getFormatedDate = (dateTime: string) => {
    return getDayMonthAndYear(dateTime) + ' ' + getHour(dateTime);
}

export {
    getDay,
    getMonth,
    getDayMonthAndYear,
    getMonthAndYear,
    getHour,
    isDateToday,
    getDateStringFromIso,
    getTimeStringFromIso,
    dateToIso,
    dateFromIso,
    getFormatedDate,
}
